exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-list-screen .details-link:hover {\n  color: blue;\n}\n.group-list-screen .wide-table {\n  width: 100%;\n}\n", ""]);

// exports
